import type { DmMessagePatientTriage } from '../../../../services/dmMessagesInbox';
import type { PickerMenuAlign } from '../../../shared/picker/PickerMenuShell';
import { PriorityPicker } from '../../../work-queue/priority/PriorityPicker';
import { AiMarkedControl } from './AiSetMarker';
import { FrustrationPicker } from './FrustrationPicker';
import { triageSetByText } from './triageSetBy';
import { useTriageSetters } from './useTriageSetters';

type TriageLevelFields = 'urgency' | 'frustration' | 'urgencyByAi' | 'frustrationByAi';

// The list row has the levels and AI flags; set-by fields arrive with the patient detail.
export type TriageControlsValue = Pick<DmMessagePatientTriage, TriageLevelFields> &
    Partial<Omit<DmMessagePatientTriage, TriageLevelFields>>;

export interface TriageControlProps {
    patientId: string;
    triage: TriageControlsValue;
    align?: PickerMenuAlign;
}

export function TriagePriorityControl({ patientId, triage, align = 'left' }: TriageControlProps) {
    const { setUrgency } = useTriageSetters(patientId, triage);
    return (
        <AiMarkedControl byAi={triage.urgencyByAi}>
            <PriorityPicker
                heading="Priority"
                requireExtremeReason={false}
                value={triage.urgency}
                onSelect={setUrgency}
                align={align}
                ariaLabel="Priority"
                tooltip={triageSetByText(triage.urgencySetBy, triage.urgencySetAt)}
            />
        </AiMarkedControl>
    );
}

export function TriageFrustrationControl({
    patientId,
    triage,
    align = 'left'
}: TriageControlProps) {
    const { setFrustration } = useTriageSetters(patientId, triage);
    return (
        <AiMarkedControl byAi={triage.frustrationByAi}>
            <FrustrationPicker
                value={triage.frustration}
                onSelect={setFrustration}
                align={align}
                ariaLabel="Frustration"
                tooltip={triageSetByText(triage.frustrationSetBy, triage.frustrationSetAt)}
            />
        </AiMarkedControl>
    );
}
